import { useEffect, useState } from "react";
import { MapPin, Star, Phone, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Clinics({ limit }) {
    const [clinics, setClinics] = useState([]);
    useEffect(() => {
        api.get("/clinics").then((r) => setClinics(r.data)).catch(() => {});
    }, []);
    const list = limit ? clinics.slice(0, limit) : clinics;

    return (
        <section className="section" data-testid="clinics-section">
            <div className="container-x">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
                    <div className="max-w-[640px]">
                        <p className="eyebrow">HearClear Network</p>
                        <h2 className="font-serif text-[40px] md:text-[56px] leading-[1.04] mt-3">
                            Expert support across <span className="italic text-[#003E4D]">40+ HearClear clinics.</span>
                        </h2>
                        <p className="mt-5 text-[16px] text-[#4a5568] leading-relaxed max-w-[520px]">
                            Free hearing test, expert fitting and lifetime service through HearClear's
                            RCI-certified audiologist network.
                        </p>
                    </div>
                    <Link to="/clinics" className="btn-secondary self-start" data-testid="all-clinics-link">All clinics <ArrowRight size={16} /></Link>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                    {list.map((c) => (
                        <article key={c.id} className="card-premium p-6" data-testid={`clinic-card-${c.id}`}>
                            <div className="flex items-start gap-3">
                                <span className="w-9 h-9 rounded-full bg-[#003E4D]/[0.07] flex items-center justify-center text-[#003E4D] shrink-0">
                                    <MapPin size={16} />
                                </span>
                                <div className="flex-1">
                                    <h3 className="font-serif text-[20px] leading-tight text-[#1a1a1a]">{c.name}</h3>
                                    <p className="text-[13px] text-[#4a5568] mt-1">{c.address}</p>
                                    {c.rating && (
                                        <p className="text-[12.5px] text-[#4a5568] mt-2 flex items-center gap-1">
                                            <Star size={12} className="text-[#f5a623] fill-[#f5a623]" /> {c.rating}
                                        </p>
                                    )}
                                </div>
                            </div>
                            {c.phone && (
                                <a href={`tel:${c.phone}`} className="inline-flex items-center gap-2 text-[13px] text-[#003E4D] mt-4 font-semibold hover:underline">
                                    <Phone size={13} /> {c.phone}
                                </a>
                            )}
                            <Link to={`/clinics/${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")}`}
                                className="mt-3 inline-flex items-center gap-1 text-[13px] text-[#0F6B7D] underline" data-testid={`clinic-detail-link-${c.id}`}>
                                Clinic details <ArrowRight size={12} />
                            </Link>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
